<template>
  <WdsRadioGroup v-model:checked="internalModelValue" :name="name">
    <WdsRadio value="nl_limited" :disabled="disabled">
      <WdsText
        :text="$t('BV (Limited Company)')"
        :sub-text="$t('You have a BV (Besloten Vennootschap) registered with the Chamber of Commerce (KVK)')"
      />
    </WdsRadio>
    <WdsRadio value="nl_sole_trader" :disabled="disabled">
      <WdsText
        :text="$t('Eenmanszaak / ZZP\'er (Sole Trader)')"
        :sub-text="$t('You are registered as a sole trader (Eenmanszaak) or self-employed (ZZP\'er) with the Chamber of Commerce (KVK)')"
      />
    </WdsRadio>
    <WdsRadio value="nl_general_partnership" :disabled="disabled">
      <WdsText
        :text="$t('VOF')"
        :sub-text="$t('You have a General Partnership (Vennootschap onder firma) registered with the Chamber of Commerce (KVK).')"
      />
    </WdsRadio>
    <WdsRadio value="nl_professional_partnership" :disabled="disabled">
      <WdsText
        :sub-text="$t('You have a Professional Partnership (Maatschap) registered with the Chamber of Commerce (KVK).')"
      >
        {{ $t('Maatschap') }}
        <WdsTooltip
          :text="$t('A Maatschap is usually for &quot;liberal&quot; or &quot;practitioner&quot; professions (like consultants, doctors, or architects) who work together to share resources. In a Maatschap, you are generally only liable for an equal share of debts, rather than the total amount.')"
          left
        >
          <WdsIcon :name="WdsIconNameEnum.HELP" class="tw-text-indigo-500" size="14" />
        </WdsTooltip>
      </WdsText>
    </WdsRadio>
    <WdsRadio value="no_setup" :disabled="disabled">
      <WdsText
        :text="$t('No business setup')"
        :sub-text="$t('You work without a business entity (available for hires via payroll)')"
      />
    </WdsRadio>
  </WdsRadioGroup>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import {
  WdsIcon,
  WdsIconNameEnum,
  WdsRadio,
  WdsRadioGroup,
  WdsText,
  WdsTooltip,
} from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'

const { $t } = useTranslation()

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const internalModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
